module.exports = __webpack_public_path__ + "static/icon_color_hiking-2b3f5499db34587ae94dd7059c2b2b8b.png";